import { SvgIconProps } from '@material-ui/core';
import React from 'react';

const ApproveEnrollmentIcon = (props: SvgIconProps): JSX.Element => (
  <svg
    fill="none"
    height="39"
    viewBox="0 0 43 42"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.7956 31.145V4.34945C27.7956 3.46112 27.4427 2.60917 26.8146 1.98103C26.1864 1.35289 25.3345 1 24.4461 1H4.34945C3.46112 1 2.60917 1.35289 1.98103 1.98103C1.35289 2.60917 1 3.46112 1 4.34945V31.145L7.6989 27.7956L14.3978 31.145L21.0967 27.7956L27.7956 31.145Z"
      stroke="#219653"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66567"
    />
    <path
      d="M22.1562 15.1387C22.6133 15.1387 23 15.5254 23 15.9824C23 18.9355 20.5742 21.3262 17.6562 21.3262H10.0977L12.3125 23.5762C12.6641 23.8926 12.6641 24.4199 12.3125 24.7363C12.1719 24.9121 11.9609 24.9824 11.75 24.9824C11.5039 24.9824 11.293 24.9121 11.1172 24.7363L7.46094 21.0801C7.14453 20.7637 7.14453 20.2363 7.46094 19.9199L11.1172 16.2637C11.4688 15.9121 11.9961 15.9121 12.3125 16.2637C12.6641 16.5801 12.6641 17.1074 12.3125 17.4238L10.0977 19.6387H17.6562C19.6602 19.6387 21.3125 18.0215 21.3125 15.9824C21.3125 15.5254 21.6641 15.1387 22.1562 15.1387ZM10.3438 12.3262C8.30469 12.3262 6.6875 13.9785 6.6875 15.9824C6.6875 16.4746 6.30078 16.8262 5.84375 16.8262C5.35156 16.8262 5 16.4746 5 15.9824C5 13.0645 7.39062 10.6387 10.3438 10.6387H17.8672L15.6523 8.42383C15.3008 8.10742 15.3008 7.58008 15.6523 7.26367C15.9688 6.91211 16.4961 6.91211 16.8125 7.26367L20.4688 10.9199C20.8203 11.2363 20.8203 11.7637 20.4688 12.0801L16.8125 15.7363C16.6719 15.9121 16.4609 15.9824 16.25 15.9824C16.0039 15.9824 15.793 15.9121 15.6523 15.7363C15.3008 15.4199 15.3008 14.8926 15.6523 14.5762L17.8672 12.3262H10.3438Z"
      fill="#219653"
    />
    <circle
      cx="31.4228"
      cy="29.9438"
      fill="#219653"
      r="10.4121"
      stroke="white"
      strokeWidth="1.67"
    />
    <g clipPath="url(#clip0_19750_150436)">
      <path
        d="M36.9566 25.8428H35.9897C35.8542 25.8428 35.7255 25.905 35.6425 26.0115L29.9394 33.2362L27.2047 29.7712C27.1634 29.7187 27.1107 29.6762 27.0505 29.647C26.9904 29.6177 26.9244 29.6025 26.8576 29.6024H25.8907C25.798 29.6024 25.7468 29.7089 25.8035 29.7809L29.5922 34.5807C29.7693 34.8048 30.1096 34.8048 30.288 34.5807L37.0438 26.0198C37.1005 25.9493 37.0493 25.8428 36.9566 25.8428Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_19750_150436">
        <rect
          fill="white"
          height="12.3939"
          transform="translate(25.2261 24.1001)"
          width="12.3939"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ApproveEnrollmentIcon;
